// interfaces
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { ModalContainerVariantType } from '../../../../../../components/modalContainer/types/modalContainer';
import { commonStyles } from '../commonStyles';
export const getDefaultStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [ModalContainerVariantType.DEFAULT]: {
            ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
            container: {
                ...commonStyles(FOUNDATIONS, FONT, SHADOWS).container,
                [DeviceBreakpointsType.DESKTOP]: {
                    border_radius: FOUNDATIONS.radius_comp_containers_modal_desktopradius_radiussize,
                    min_width: '37.5rem',
                    min_height: '15rem',
                    max_width: 'calc(100vw - 36px)',
                    max_height: 'calc(100vh - 36px)',
                },
                [DeviceBreakpointsType.TABLET]: {
                    border_radius: `${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} ${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} 0 0`,
                    min_width: '48rem',
                    min_height: '16rem',
                    max_width: '100vw',
                    max_height: '100vh',
                },
                [DeviceBreakpointsType.MOBILE]: {
                    border_radius: `${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} ${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} 0 0`,
                    max_width: '100vw',
                    max_height: '100vh',
                },
            },
            actionsAndHeaderContainer: {
                ...commonStyles(FOUNDATIONS, FONT, SHADOWS).actionsAndHeaderContainer,
                [DeviceBreakpointsType.DESKTOP]: {
                    padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_300}`,
                },
                [DeviceBreakpointsType.TABLET]: {
                    padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250}`,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250}`,
                },
            },
            titleContainer: {
                ...commonStyles(FOUNDATIONS, FONT, SHADOWS).titleContainer,
                [DeviceBreakpointsType.DESKTOP]: {
                    margin_bottom: FOUNDATIONS.spacing_250,
                },
                [DeviceBreakpointsType.TABLET]: {
                    margin_bottom: FOUNDATIONS.spacing_250,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    margin_bottom: FOUNDATIONS.spacing_250,
                },
            },
            content: {
                ...commonStyles(FOUNDATIONS, FONT, SHADOWS).content,
                [DeviceBreakpointsType.DESKTOP]: {
                    margin_bottom: FOUNDATIONS.spacing_300,
                    padding_left: FOUNDATIONS.spacing_300,
                    padding_right: FOUNDATIONS.spacing_300,
                },
                [DeviceBreakpointsType.TABLET]: {
                    margin_bottom: FOUNDATIONS.spacing_300,
                    padding_left: FOUNDATIONS.spacing_250,
                    padding_right: FOUNDATIONS.spacing_250,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    margin_bottom: FOUNDATIONS.spacing_300,
                    padding_left: FOUNDATIONS.spacing_250,
                    padding_right: FOUNDATIONS.spacing_250,
                },
            },
            footer: {
                [DeviceBreakpointsType.DESKTOP]: {
                    padding_top: FOUNDATIONS.spacing_250,
                    padding_bottom: FOUNDATIONS.spacing_250,
                    width: `calc(100% - (${FOUNDATIONS.spacing_300} + ${FOUNDATIONS.spacing_300}))`,
                },
                [DeviceBreakpointsType.TABLET]: {
                    width: `calc(100% - (${FOUNDATIONS.spacing_250} + ${FOUNDATIONS.spacing_250}))`,
                    padding_bottom: FOUNDATIONS.spacing_250,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    width: `calc(100% - (${FOUNDATIONS.spacing_250} + ${FOUNDATIONS.spacing_250}))`,
                    padding_bottom: FOUNDATIONS.spacing_250,
                },
            },
        },
    };
};
//# sourceMappingURL=default.js.map